document.addEventListener("DOMContentLoaded", function () {
  const swiperContainer = document.querySelector(".swiper.autoplay-video");

  // Read the data attributes
  const desktopItems =
    parseInt(swiperContainer.getAttribute("data-desktop")) || 4;
  const mobileItems =
    parseInt(swiperContainer.getAttribute("data-mobile")) || 1;

  const swiper = new Swiper(".swiper.autoplay-video", {
    loop: true,
    // autoplay: {
    //   delay: 3000,
    // },
    slidesPerView: mobileItems, // Fallback
    spaceBetween: 20,

    // Responsive breakpoints
    breakpoints: {
      768: {
        slidesPerView: desktopItems,
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
});
